var exports = {
  "kL": "SidebarShellSkeleton.module__container___anV5TF",
  "Kd": "SidebarShellSkeleton.module__containerMobile___anV5TF",
  "DF": "SidebarShellSkeleton.module__headerFrame___anV5TF",
  "VH": "SidebarShellSkeleton.module__headerFrameBanner___anV5TF",
  "kW": "SidebarShellSkeleton.module__headerBanner___anV5TF",
  "wx": "SidebarShellSkeleton.module__header___anV5TF",
  "D": "SidebarShellSkeleton.module__headerCaret___anV5TF",
  "Qs": "SidebarShellSkeleton.module__content___anV5TF",
};

module.exports = exports;
